// api.js



export const fetchData = async (endpoint = "master.php") => {
    const response = await fetch(`https://www.arkadopoulos.eu/gpstracking/${endpoint}`, {
      method: 'POST',
    });
  
    if (!response.ok) {
      throw new Error('Network response was not ok ' + response.statusText);
    }
  
    return response.json();
  };
  


//master_cars
//officials